import { PricingPlanCategory } from 'src/models';

export const UNLOCK_INSIGHTS_MODAL_LOCATION = 'Unlock Insights Modal';
export const UNLOCK_INSIGHTS_DASHBOARD_PANEL_LOCATION = 'Unlock Insights Dashboard Panel';
export const UNLOCK_INSIGHTS_CALLOUT_LOCATION = 'Unlock Insights CTA Callout';
export const UNLOCK_INSIGHTS_UPSELL_NAME = 'Unlock Insights';

/** Segment `origin` when the user completes an upgrade from the Unlock Insights upsell UI. */
export const UNLOCK_INSIGHTS_PLAN_UPGRADE_ORIGIN_UPSELL = 'upsell insights';

/** Segment `origin` when the user completes an upgrade on the billing page after Unlock Insights redirect. */
export const UNLOCK_INSIGHTS_PLAN_UPGRADE_ORIGIN_BILLING = 'billing page';

export interface UnlockInsightsFeatureColumn {
  icon: string;
  titleKey: string;
  descriptionKey?: string;
  items: string[];
}

const BASIC_COLUMNS: UnlockInsightsFeatureColumn[] = [
  {
    icon: 'monitor_heart_two_tone',
    titleKey: 'dashboard.unlockInsightsModal.columns.activitySummary.title',
    descriptionKey: 'dashboard.unlockInsightsModal.columns.activitySummary.description',
    items: [
      'dashboard.unlockInsightsModal.columns.activitySummary.items.idleMinutes',
      'dashboard.unlockInsightsModal.columns.activitySummary.items.manualMobile',
      'dashboard.unlockInsightsModal.columns.activitySummary.items.userActivityLevels',
    ],
  },
  {
    icon: 'web_two_tone',
    titleKey: 'dashboard.unlockInsightsModal.columns.webAndAppUsage.title',
    descriptionKey: 'dashboard.unlockInsightsModal.columns.webAndAppUsage.description',
    items: [
      'dashboard.unlockInsightsModal.columns.webAndAppUsage.items.topUsed',
      'dashboard.unlockInsightsModal.columns.webAndAppUsage.items.topUnrated',
      'dashboard.unlockInsightsModal.columns.webAndAppUsage.items.topUnproductive',
    ],
  },
  {
    icon: 'area_chart_two_tone',
    titleKey: 'dashboard.unlockInsightsModal.columns.productivity.title',
    descriptionKey: 'dashboard.unlockInsightsModal.columns.productivity.description',
    items: [
      'dashboard.unlockInsightsModal.columns.productivity.items.percentages',
      'dashboard.unlockInsightsModal.columns.productivity.items.highestProductive',
      'dashboard.unlockInsightsModal.columns.productivity.items.highestUnproductive',
    ],
  },
];

const STANDARD_COLUMNS: UnlockInsightsFeatureColumn[] = [
  {
    icon: 'groups_two_tone',
    titleKey: 'dashboard.unlockInsightsModal.columns.meetingInsights.title',
    descriptionKey: 'dashboard.unlockInsightsModal.columns.meetingInsights.description',
    items: [
      'dashboard.unlockInsightsModal.columns.meetingInsights.items.lowestMeetingTime',
      'dashboard.unlockInsightsModal.columns.meetingInsights.items.highestMeetingTime',
      'dashboard.unlockInsightsModal.columns.meetingInsights.items.usersHighestMeetingTime',
    ],
  },
  {
    icon: 'area_chart',
    titleKey: 'dashboard.unlockInsightsModal.columns.benchmarkingAi.title',
    descriptionKey: 'dashboard.unlockInsightsModal.columns.benchmarkingAi.description',
    items: [
      'dashboard.unlockInsightsModal.columns.benchmarkingAi.items.shareOfTimeBreakdown',
      'dashboard.unlockInsightsModal.columns.benchmarkingAi.items.shareOfUnusualActivity',
      'dashboard.unlockInsightsModal.columns.benchmarkingAi.items.appsUsageBreakdown',
    ],
  },
  {
    icon: 'space_dashboard_two_tone',
    titleKey: 'dashboard.unlockInsightsModal.columns.executiveDashboard.title',
    descriptionKey: 'dashboard.unlockInsightsModal.columns.executiveDashboard.description',
    items: [
      'dashboard.unlockInsightsModal.columns.executiveDashboard.items.benchmarks',
      'dashboard.unlockInsightsModal.columns.executiveDashboard.items.highestAvgHours',
      'dashboard.unlockInsightsModal.columns.executiveDashboard.items.highestProductive',
    ],
  },
];

export function getUnlockInsightsColumns(
  pricingPlanCategory: PricingPlanCategory | null | undefined,
): UnlockInsightsFeatureColumn[] {
  return pricingPlanCategory === 'standard' ? STANDARD_COLUMNS : BASIC_COLUMNS;
}
